import { createAction, props } from '@ngrx/store';
import { Calendar } from 'src/app/models/calendar/calendar';
import { Role } from 'src/app/models/role/role';

export const calendarList = createAction(
  '[Calendars] list'
);

export const calendarListSuccess = createAction(
  '[Calendars] list success',
  props<{calendars: Calendar[]}>()
);

export const rolesList = createAction(
  '[Roles] list'
);

export const rolesListSuccess = createAction(
  '[Roles] list success',
  props<{roles: Role[]}>()
);
